export default "__VITE_ASSET__Cp9w4dNP__"